<template>
    <!-- Start Tabs Section -->
    <section class="tabs">
        <!-- Start Container -->
        <div class="container">
            <!-- Start Row -->
            <div class="row">
                <!-- Start Column -->
                <div class="col-lg-2 col-xl-2">
                    <button
                        v-for="tab_info in tabs_info"
                        :key="tab_info.id"
                        :class="[{'selected': selected === tab_info.id},'tab-button']"
                        @click="selected = tab_info.id"
                    >
                        {{ tab_info.button_value.toUpperCase() }}
                    </button>
                </div>
                <!-- End Column -->
                <!-- Start Column -->
                <div class="col-lg-10 col-xl-7">
                    <!-- Start Tabs Content -->
                    <div class="tabs-content">
                        <!-- Start Tab Content -->
                        <div
                            class="tab-content"
                            v-for="tab_info in tabs_info"
                            :key="tab_info.id"
                            v-show="selected === tab_info.id"
                        >
                            <h4 class="tab-title">
                                Tabs <span>{{ tab_info.tab_number }}</span> With Soft Transitioning Effect
                            </h4>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                            </p>
                            <button class="btn btn-lg download">Download</button>
                        </div>
                    </div>
                    <!-- End Tabs Content -->
                </div>
                <!-- End Column -->
                <!-- Start Column -->
                <div class="col-xl-3">
                    <div class="tab-image">
                        <img src="../../assets/images/tabs.png" alt="Tab Image">
                    </div>
                </div>
                <!-- End Column -->
            </div>
            <!-- End Row -->
        </div>
        <!-- End Container -->
    </section>
    <!-- End Tabs Section -->
</template>

<style scoped lang="scss">

.tabs{
    padding: var(--main-padding);
    background-color: var(--second-background);
    button.tab-button{
        display: block;
        width: 100%;
        background-color: var(--main-background);
        color: #FFF;
        border: none;
        border-bottom: 1px solid #FFF;
        height: 100px;
        font-size: 20px;
        &.selected{
            background-color: var(--main-color);
        }
        @media(max-width: 991px){
            height: 70px
        }
    }

    .tabs-content{
        padding-top: 20px;
        .tab-title{
            margin-bottom: 20px;
            span{
                color: var(--main-color)
            }
            @media(max-width: 991px){
                margin-top: 20px
            }
        }
        p{
            font-size: 15px;
            line-height: 1.7
        }
        button.download{
            background-color: #f0ad4e;
            border-color: #eea236;
            color: #FFF;
            &:hover{
                background-color: #ec971f
            }
        }

        @media(max-width: 991px){
            padding-bottom: 10px
        }
    }

    .tab-image{
        padding-top: 20px;
        @media(max-width: 991px){
            padding-bottom: 20px
        }
        @media(max-width: 1199px){
            text-align: center;
            padding: {
                top: 30px;
                bottom: 30px
            }
        }
    }

    @media(max-width: 991px) {
        text-align: center
    }

}    

</style>

<script>

import {tabs_info} from "../../assets/jsonData/index.json"

export default {

    name: "tabs",

    data: function () {
        
        return {

            tabs_info,

            selected: 1

        }

    }

}

</script>